import * as React from "react";
import QuestionLabel from "./QuestionLabel";
import QuestionError from "./QuestionError";
import getControlProps from "../helpers/getControlProps";

interface RadioQuestionProps {
  question: any;
  onChange: any;
  error: string;
}

class RadioQuestion extends React.Component<RadioQuestionProps, {}> {
  onChange = (e: React.FormEvent<HTMLInputElement>) => {
    if (e.currentTarget.checked) {
      e.currentTarget.setAttribute("aria-checked", "true");
    } else {
      e.currentTarget.setAttribute("aria-checked", "false");
    }

    this.props.onChange(this.props.question, e.currentTarget.value);
  };

  render() {
    const nameAttr = "velaro-answer-" + this.props.question.QuestionID;

    return (
      <div role="radiogroup" aria-label={this.props.question.QuestionText}>
        <QuestionLabel question={this.props.question} />
        {this.props.question.SurveyQuestionChoices.map((choice: any) => {
          const inputId = `velaro-choice-${choice.ChoiceID}`;
          return (
            <div className="radio" key={choice.ChoiceID}>
              <input
                role="radio"
                aria-checked="false"
                type="radio"
                id={inputId}
                name={nameAttr}
                value={choice.ChoiceText}
                onChange={this.onChange}
              />
              <label htmlFor={inputId}>{choice.ChoiceText}</label>
            </div>
          );
        })}
        <QuestionError
          questionId={this.props.question.QuestionID}
          error={this.props.error}
        />
      </div>
    );
  }
}

export default RadioQuestion;
